import { AuthContext } from '@core/shared';
import { WebinarStatus } from '@core/types';
import { Link } from '@online-webinar/ui-frontend';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { WebinarButtonProps } from './types';

export const WebinarButton = ({ classNames, id, status, title }: WebinarButtonProps) => {
    const { t } = useTranslation();
    const isVerified = useContext(AuthContext).isVerified;
    const linkContext = <span className="sr-only">{t('Generic.Link.Context', { title })}</span>;

    return (
        <>
            {status === WebinarStatus.Planned && (
                <Link to="/$webinarId/broadcast" params={{ webinarId: id }} variant="success" classNames={classNames} disabled={!isVerified}>
                    {t('WebinarButton.Status.Planned')}
                    {linkContext}
                </Link>
            )}

            {status === WebinarStatus.Started && (
                <Link to="/$webinarId/broadcast" params={{ webinarId: id }} variant="success" classNames={classNames} disabled={!isVerified}>
                    {t('WebinarButton.Status.Started')}
                    {linkContext}
                </Link>
            )}

            {status === WebinarStatus.Ended && (
                <Link to="/$webinarId/insights" params={{ webinarId: id }} state={{ backTo: 'overview' }} variant="primary-outline" classNames={classNames}>
                    {t('WebinarButton.Status.Ended')}
                    {linkContext}
                </Link>
            )}
        </>
    );
};
